import React, { useMemo } from 'react';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import { InboxOutlined } from '@ant-design/icons';
import { Descriptions } from 'antd';

const FileSection = ({ file }) => {
  const { t } = useTranslation();

  const fileList = useMemo(() => {
    const l = [];
    if (file) {
      l.push({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.url,
      });
    }

    return l;
  }, [file]);
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          name='file'
          getValueFromEvent={FormHelper.normFile}
          multiple={false}
        >
          <Upload.Dragger
            multiple={false}
            beforeUpload={FormHelper.beforeUpload}
            defaultFileList={fileList}
          >
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>
              {t('Click or drag file to this area to upload1')}
              'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX'
              {t('Click or drag file to this area to upload2')}
            </p>
          </Upload.Dragger>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
